import React, { useCallback, useContext, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { BoxClass, NodeById } from '../../../helper/classes'
import { Button, ButtonGroup, Icon, NonIdealState, Tooltip, UL } from '@blueprintjs/core'
import { OverlayProps } from '../../../helper/configs'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import {
  copyTextToClipBoard,
  reorderForBnD,
  showToastByMenuDirection,
  truncateDefault
} from '../../../helper/functions'
import { produce } from 'immer'
import { useTranslation } from 'react-i18next'

function SharedNodesAddon () {
  const { t } = useTranslation()

  const [rawSharedNodeIds, setRawSharedNodeIds] = useState(globalOnDemandVars.sharedNodeIds())
  const sharedNodes = useMemo(() => (rawSharedNodeIds.map((nodeId) => (new NodeById(nodeId)))), [rawSharedNodeIds])
  // useEffect(() => {
  //   console.tron.display({
  //     name: 'SharedNodesAddon',
  //     preview: isPixelMode,
  //     value: {
  //       isPixelMode,
  //       currentList: lastClosedList,
  //       lastClosedListForPixelMode: contextValue.lastClosedListForPixelMode,
  //       lastClosedList: contextValue.lastClosedList
  //     }
  //     // , important: true
  //   })
  // }, [contextValue.lastClosedList, contextValue.lastClosedListForPixelMode, isPixelMode, lastClosedList])

  const [isDragging, setIsDragging] = useState(false)
  const onDragStart = useCallback(
    () => {
      setIsDragging(true)
    },
    []
  )
  const onDragEnd = useCallback((result) => {
    setIsDragging(false)
    if (!result.destination) {
      return
    }

    const nextItems = reorderForBnD(
      rawSharedNodeIds,
      result.source.index,
      result.destination.index
    )
    setRawSharedNodeIds(nextItems)
    globalOnDemandVars.set_sharedNodeIds(nextItems)
  }, [rawSharedNodeIds, setRawSharedNodeIds])

  const inDroppable = useMemo(() => (sharedNodes.map((node, i) => {
    const titleFound = node.getTitle()
    return (<Draggable key={node.id} draggableId={node.id} index={i}>{
      (provided, snapshot) => (
        <div ref={provided.innerRef} {...provided.draggableProps} key={node.id}
          css={css`display: flex; border-bottom: 1px dotted var(--gray5);
        & .visibleIfHover {
          visibility: hidden;
        }
        & .grabCursor {
          cursor: grab;
        }
        & .grabCursor:active {
          cursor: grabbing;      
        }
        &:hover .visibleIfHover {
          visibility: visible;
        }
`}
        >
          <div className={'bp3-button bp3-icon-drag-handle-vertical bp3-minimal visibleIfHover grabCursor'} {...provided.dragHandleProps} />
          <div css={css`flex: auto;`}>
            <Button title={titleFound || ''} icon={'dot'} disabled={titleFound === false} minimal onClick={() => {
              node.onClick()
            }}>{titleFound === false ? t('Deleted') : (titleFound ? truncateDefault(titleFound) : <span css={css`color: var(--gray6);`}>Blank</span>)}</Button>
          </div>
          <ButtonGroup minimal className={'visibleIfHover'}>
            <Tooltip {...OverlayProps} content={t('Copy the URL for Sharing')}>
              <Button icon={'share'} minimal onClick={() => {
                copyTextToClipBoard(`https://app.learnobit.com/#/sharing/${globalOnDemandVars.userData().uid}/${node.id}`).then(() => {
                  showToastByMenuDirection({
                    icon: 'share',
                    message: t('The URL for sharing is copied')
                  })
                })
              }} />
            </Tooltip>
            <Tooltip {...OverlayProps} content={t('Stop Sharing')}>
              <Button icon={'trash'} minimal onClick={() => {
                const newIds = produce(rawSharedNodeIds, draft => {
                  const index = draft.findIndex((nodeId) => (nodeId === node.id))
                  draft.splice(index, 1)
                })
                setRawSharedNodeIds(newIds)
                globalOnDemandVars.set_sharedNodeIds(newIds)
              }} /></Tooltip>
          </ButtonGroup>
        </div>)}</Draggable>
    )
  })), [rawSharedNodeIds, sharedNodes, t])

  const result = useMemo(() => ((
    <div onMouseEnter={() => {
      setRawSharedNodeIds(globalOnDemandVars.sharedNodeIds())
    }}>
      {sharedNodes.length ? null : <NonIdealState css={css`
& > .bp3-non-ideal-state-visual {
  font-size: 70px;
}
      `} icon={<Icon icon={'delete'} iconSize={35} />} description={<div css={css`font-weight: bold;`}>{t('Nothing Here')}</div>} />}
      {sharedNodes.length ? (<DragDropContext
        // TODO 항목 아무것도 없으면 null 시키기
        // onBeforeDragStart={onBeforeDragStart}
        onDragStart={onDragStart}
        // onDragUpdate={onDragUpdate}
        onDragEnd={onDragEnd}
      >
        <Droppable droppableId='bookmarks'>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{
                backgroundColor: (isDragging && !snapshot.isDraggingOver) ? '#FFB366' : 'transparent'
              }}
              {...provided.droppableProps}
            >
              {inDroppable}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>) : null}
    </div>
  )
  ), [sharedNodes.length, t, onDragStart, onDragEnd, isDragging, inDroppable])
  return result
}

// function SharedNodesAddon (props) {
//   return (
//     <GlobalContext.Consumer>
//       {({ lastClosedList }) => (<InnerLastClosedAddOn
//         {...props} contextValue={{ lastClosedList }}
//       />)}
//     </GlobalContext.Consumer>
//   )
// }

const SharedNodesAddOnBoxClass = new BoxClass(SharedNodesAddon, 'Shared Nodes', null, 3, { order: 2.5 })

export default SharedNodesAddOnBoxClass

export { SharedNodesAddon }
